<div class="fm-stat-section fm-mt-10px fm-mb-10px">
    <div class="customHr">.</div>

    <!-- No Streaks -->
    <div *ngIf="monthlyStreak == 0 && weeklyStreak == 0" class="stat-group">
        <div class="fm-stat-container">
            <div class="fm-stat-val text-center">{{ compSessions }}</div>
            <div class="fm-stat-name text-center">Sessions </div>
        </div>
        <div class="fm-stat-container">
            <div
                *ngIf="compSessions != 0"
                [style.color]="scoreColor"
                class="fm-stat-val text-center"
                >{{ attendanceScore }}%</div
            >
            <div
                *ngIf="compSessions == 0"
                [style.color]="scoreColor"
                class="fm-stat-val text-center"
                >N/A</div
            >
            <div class="fm-stat-name text-center"
                >Timeliness
                <span class="text-nowrap"
                    >Score
                    <mat-icon
                        class="size-12"
                        matTooltip="The percentage of your last 20 sessions that you joined less than 5 minutes late. Only you can see this score."
                        matTooltipPosition="above"
                        matTooltipShowDelay="100"
                        matTooltipClass="f-tooltip"
                        >help</mat-icon
                    >
                </span>
            </div>
        </div>
    </div>

    <!-- Just Monthly Streak -->
    <div *ngIf="monthlyStreak != 0 && weeklyStreak == 0" class="stat-group">
        <div class="fm-stat-container">
            <div class="fm-stat-val text-center">{{ compSessions }}</div>
            <div class="fm-stat-name text-center">Sessions </div>
        </div>
        <div class="fm-stat-container">
            <div
                *ngIf="compSessions != 0"
                [style.color]="scoreColor"
                class="fm-stat-val text-center"
                >{{ attendanceScore }}%</div
            >
            <div
                *ngIf="compSessions == 0"
                [style.color]="scoreColor"
                class="fm-stat-val text-center"
                >N/A</div
            >
            <div class="fm-stat-name text-center"
                >Timeliness
                <span class="text-nowrap"
                    >Score
                    <mat-icon
                        class="size-12"
                        matTooltip="The percentage of your last 20 sessions that you joined less than 5 minutes late. Only you can see this score."
                        matTooltipPosition="above"
                        matTooltipShowDelay="100"
                        matTooltipClass="f-tooltip"
                        >help</mat-icon
                    >
                </span>
            </div>
        </div>
        <div *ngIf="monthlyStreak != 0 && weeklyStreak == 0" class="fm-stat-container">
            <div class="fm-stat-val text-center">{{ monthlyStreak }}</div>
            <div class="fm-stat-name text-center"
                >Monthly
                <span class="text-nowrap"
                    >Streak
                    <mat-icon
                        class="size-12"
                        matTooltip="Your streak shows how many months in a row you have had at least one session. For a session to count toward your streak, it has to be matched, and you have to attend on-time! Keep your streak alive!!"
                        matTooltipPosition="above"
                        matTooltipShowDelay="100"
                        matTooltipClass="f-tooltip"
                        >help</mat-icon
                    >
                </span>
            </div>
        </div>
    </div>

    <!-- Monthly and Weekly Streaks -->

    <div *ngIf="monthlyStreak != 0 && weeklyStreak != 0" class="all-stats-group">
        <div class="stat-group">
            <div class="fm-stat-container">
                <div class="fm-stat-val text-center">{{ compSessions }}</div>
                <div class="fm-stat-name text-center">Sessions </div>
            </div>
            <div class="fm-stat-container">
                <div
                    *ngIf="compSessions != 0"
                    [style.color]="scoreColor"
                    class="fm-stat-val text-center"
                    >{{ attendanceScore }}%</div
                >
                <div
                    *ngIf="compSessions == 0"
                    [style.color]="scoreColor"
                    class="fm-stat-val text-center"
                    >N/A</div
                >
                <div class="fm-stat-name text-center"
                    >Timeliness
                    <span class="text-nowrap"
                        >Score
                        <mat-icon
                            class="size-12"
                            matTooltip="The percentage of your last 20 sessions that you joined less than 5 minutes late. Only you can see this score."
                            matTooltipPosition="above"
                            matTooltipShowDelay="100"
                            matTooltipClass="f-tooltip"
                            >help</mat-icon
                        >
                    </span>
                </div>
            </div>
        </div>

        <div class="stat-group fm-mt-20px">
            <div *ngIf="monthlyStreak != 0" class="fm-stat-container">
                <div class="fm-stat-val text-center">{{ monthlyStreak }}</div>
                <div class="fm-stat-name text-center"
                    >Monthly
                    <span class="text-nowrap"
                        >Streak
                        <mat-icon
                            class="size-12"
                            matTooltip="Your streak shows how many months in a row you have had at least one session. For a session to count toward your streak, it has to be matched, and you have to attend on-time! Keep your streak alive!!"
                            matTooltipPosition="above"
                            matTooltipShowDelay="100"
                            matTooltipClass="f-tooltip"
                            >help</mat-icon
                        >
                    </span>
                </div>
            </div>
            <div class="fm-stat-container">
                <div class="fm-stat-val text-center">{{ weeklyStreak }}</div>
                <div class="fm-stat-name text-center"
                    >Weekly
                    <span class="text-nowrap"
                        >Streak
                        <mat-icon
                            class="size-12"
                            matTooltip="Your streak shows how many weeks in a row you have had at least one session. For a session to count toward your streak, it has to be matched, and you have to attend on-time! Keep your streak alive!!"
                            matTooltipPosition="above"
                            matTooltipShowDelay="100"
                            matTooltipClass="f-tooltip"
                            >help</mat-icon
                        >
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
